$(document).ready(function(e) {

	var url = $(location).attr('href').split("/").splice(0, 5).join("/");
	var segments = url.split( '/' );
	var lang = segments[3];
	if(lang=='') {lang = 'ro';}
	var two_segment = segments[4];

	/*mob_menu*/
	$('.m_ctrl').on('click', function() {
		$(this).toggleClass('active');
		$('.menu_mob_wr').fadeToggle(300)
	});

	/*b_info4*/
	$('.b_info4').on('click', '.open_close', function() {
		$(this).parent().toggleClass('open');
		$(this).parent().children('.ddown').slideToggle(300);
	});

	/*fancybox*/
	$("[data-fancybox]").fancybox({
		buttons : [
			'close'
		],
		afterShow: function() {
			$('input, select').styler().trigger('refresh');
			$('.switch input').styler('destroy');
			$('.switch1 input').styler('destroy');
			$('#amount').styler('destroy');
			$('input[type="checkbox"]').styler('destroy');
		}
	});

	/*Форма*/
	$('input:not(.statin), select').styler({
		selectPlaceholder: '',
		selectVisibleOptions: 5,
		selectSearch: true
	});
	$('.switch input').styler('destroy');
	$('.switch1 input').styler('destroy');
	$('#amount').styler('destroy');
	$('input[type="checkbox"]').styler('destroy');

	/*Вкладки*/
	$('.tabs_wr').tabs();
	$('.tabs_wr1').tabs();

	/*tooltip*/
	$('.t_hint').tooltip({
		position: {
			my: 'left top',
			at: 'right-3 top-25'
		}
	});

	$('.ui-tabs-anchor').click(function(){
		$('input, select').trigger('refresh');
	});

	//* coloram imputurile cand avem eroare */

    $( "form input" ).each(function() {
        var error = $( this ).parents('.f_row').find('.error').text();
        var name = $( this ).parents('.f_row').find('input').attr('name');
		if(error!=''){
			$(this).parents('.f_row').find('#'+name).css('border', '1px solid #d8000c');
		}
	});
	
	// question form

	$(document).on('submit', '.question_request', function(event){

		current = $(this);
		var name = current.find('#name').val();
		var email = current.find('#email').val();
		var phone = current.find('#phone').val();
		var card = current.find('#card').val();
		var question_type = current.find('#question_type').val();
		var question = current.find('#question').val();
		var lang = current.find('#lang').val();
		
		if(name!='' && email!='' && question!='' && card!='' && question_type!=''  ) {
			$(".question_request button").css({"pointer-events": "none", "opacity": "0.4"});
			$.ajax({
				type: "POST",
				url: "/"+lang+"/ajax/question_request",
				data: {
					'name': name,
					'email': email,
					'phone': phone,
					'card': card,
					'question_type': question_type,
					'question': question,
				},
				dataType: 'json',
				success: function(res) {
					$('.question_request .responde').html(res.msg);
					if (res.error == true) {
						$('.question_request .responde').addClass('error-msg');
					} else {
						console.log(res);
						$('.question_request .responde').addClass('success-msg');
						$('.question_request #name').val('');
						$('.question_request #email').val('');
						$('.question_request #question').val('');
					}
					$(".question_request button").css({"pointer-events": "auto", "opacity": "1"});
					setTimeout(function(){
						window.location = '/'+lang+'/balance';
					}, 3000);
				},
				error: function(res){
					console.log(res);
				}
			});
		}

		event.preventDefault();
	});

	// accordion 
	
	var acc = document.getElementsByClassName("accordion");
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function() {
			this.classList.toggle("active");
			var panel = this.nextElementSibling;
			if (panel.style.maxHeight){
			panel.style.maxHeight = null;
			} else {
			panel.style.maxHeight = panel.scrollHeight + "px";
			} 
		});
	}

	// radio input in popup

	$(document).on('change', '#r1', function(){
		$( "#card-popup .b_form1>.f_row" ).each(function() {
			if($(this).hasClass('hide')) {
				$(this).removeClass('hide');
			} else {
				$(this).addClass('hide');
			}
		});
	});

	$(document).on('change', '#is_active', function(){
        var active = $(this).closest('.f_opt').find('span#active');
        var not = $(this).closest('.f_opt').find('span#not-active');
        if($(this).is(":checked")) {
            not.css({'display':'none'});
            active.css({'display':'block'});
        } else {
            active.css({'display':'none'});
            not.css({'display':'block'});
        }
    });

    $(document).on('click', '.open_close', function(event){
        event.preventDefault();
       
        var self = $(this);
        var id = self.data('id');
        var open = self.closest('.item').hasClass('open');
        if(open) {
            $.ajax({
                type: "POST",
                url: "/"+lang+"/ajax/get_card_info",
                data: {
                    'id': id,
                },
                dataType: 'json',
                success: function(res) {
                    console.log(res.data);
                    if(res.data.DailyLimit==0) res.data.DailyLimit = '-';
                    if(res.data.DailyLimitUsed==0) res.data.DailyLimitUsed = '-';
                    if(res.data.DailyLimitRemain==0) res.data.DailyLimitRemain = '-';
                    if(res.data.WeeklyLimit==0) res.data.WeeklyLimit = '-';
                    if(res.data.WeeklyLimitUsed==0) res.data.WeeklyLimitUsed = '-';
                    if(res.data.WeeklyLimitRemain==0) res.data.WeeklyLimitRemain = '-';
                    if(res.data.MonthlyLimit==0) res.data.MonthlyLimit = '-';
                    if(res.data.MonthlyLimitUsed==0) res.data.MonthlyLimitUsed = '-';
                    if(res.data.MonthlyLimitRemain==0) res.data.MonthlyLimitRemain = '-';
                    if(res.data.AdditionalLimit==0) res.data.AdditionalLimit = '-';
                    self.closest('.item').find('span.daily_limit').text(res.data.DailyLimit);
                    self.closest('.item').find('span.daily_used').text(res.data.DailyLimitUsed);
                    self.closest('.item').find('span.daily_remainder').text(res.data.DailyLimitRemain);
                    self.closest('.item').find('span.weekly_limit').text(res.data.WeeklyLimit);
                    self.closest('.item').find('span.weekly_used').text(res.data.WeeklyLimitUsed);
                    self.closest('.item').find('span.weekly_remainder').text(res.data.WeeklyLimitRemain);
                    self.closest('.item').find('span.monthly_limit').text(res.data.MonthlyLimit);
                    self.closest('.item').find('span.monthly_used').text(res.data.MonthlyLimitUsed);
                    self.closest('.item').find('span.monthly_remainder').text(res.data.MonthlyLimitRemain);
                    self.closest('.item').find('span.extra_limit').text(res.data.AdditionalLimit);
                },
                error: function(res){
                    console.log(res);
                }
            });
        }
	});
	
	$(document).on('click', '#settings-popup', function(event){
        event.preventDefault();
        var self = $(this);
        var id = self.data('id');
		var data = "card="+id;
		var loader = 
		'<div class="loader">' +
            '<div id="ld4">'+
                '<div></div><div></div><div></div><div></div>'+
            '</div>'+
        '</div>';
		$('.settings-popup-content').html('<div class="popup">'+loader+'</div>');
		$('.settings-popup-content').css({'display':'flex'});
        $.get(window.location.pathname.replace(two_segment,'popup_card')+'?'+data,function(responce) {
			$('.settings-popup-content').html(responce);
			$('input, select').styler().trigger('refresh');
			$('.switch input').styler('destroy');
			$('.switch1 input').styler('destroy');
			$('#amount').styler('destroy');
			$('input[type="number"]').styler('destroy');
			$('input[type="checkbox"]').styler('destroy');
			$('.datepicker').datepicker();
        });
	});
	
	$(document).on('click', '.popup-close', function(){
		$('.settings-popup-content').hide();
	});

	$("#rphone").inputmask({mask:"099999999"});
	$("#phone").inputmask({mask:"099999999"});
	$("#rcard").inputmask({mask:"9999999999"});
/* 	$("#ridnp").inputmask({mask:"9999999999999"});
	$("#idnp").inputmask({mask:"9999999999999"}); */
});